import { useMemo } from 'react';

import articleFragment from 'common/gql/fragments/article.gql';
import articleLabelsFragment from 'common/gql/fragments/articleLabels.gql';
import commonArticleFragment from 'common/gql/fragments/commonArticle.gql';
import { combineQueryWithFragments } from 'common/gql/utils/fragments';
import productListQuery from '../gql/query/productList.gql';
import searchProductListQuery from '../gql/query/searchProductList.gql';

export const useGetFetchProductsQuery = (isSearchMode: boolean) =>
  useMemo(
    () =>
      combineQueryWithFragments(
        isSearchMode ? searchProductListQuery : productListQuery,
        articleFragment,
        commonArticleFragment,
        articleLabelsFragment
      ),
    [isSearchMode]
  );
